export enum Status {
  NEW,
  UNDER_CONFIRMATION,
  UNDER_FAMILIARIZATION,
  ACTIVE,
  INACTIVE
}




// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/models/status.model.ts